import React from 'react'

export const DispositivosDevueltos = () => {
  return (
    <div>
    
    </div>

  )
}
